<button id="app-scroll-to-top" class="desktop" *ngIf="windowScrolled" (click)="scrollToTop()"> 
    <i class="fas fa-chevron-up fa-2x"></i>
    <br>Top
</button>

<button id="app-scroll-to-top" class="mobile" *ngIf="windowScrolled" (click)="scrollToTop()"> 
    <i class="fas fa-chevron-up fa-lg"></i>
</button>